import React, { useState, useEffect } from 'react';

const INDIA_CITIES = {
  'Andhra Pradesh': ['Visakhapatnam','Vijayawada','Guntur','Nellore','Kurnool','Rajahmundry','Tirupati','Kakinada','Kadapa','Anantapur'],
  'Arunachal Pradesh': ['Itanagar','Naharlagun','Pasighat','Tezpur'],
  'Assam': ['Guwahati','Silchar','Dibrugarh','Jorhat','Nagaon','Tinsukia','Tezpur','Bongaigaon'],
  'Bihar': ['Patna','Gaya','Bhagalpur','Muzaffarpur','Purnia','Darbhanga','Arrah','Begusarai','Katihar','Munger'],
  'Chhattisgarh': ['Raipur','Bhilai','Bilaspur','Korba','Durg','Rajnandgaon','Raigarh'],
  'Goa': ['Panaji','Margao','Vasco da Gama','Mapusa','Ponda'],
  'Gujarat': ['Ahmedabad','Surat','Vadodara','Rajkot','Bhavnagar','Jamnagar','Gandhinagar','Junagadh','Anand','Navsari'],
  'Haryana': ['Faridabad','Gurugram','Panipat','Ambala','Yamunanagar','Rohtak','Hisar','Karnal','Sonipat','Panchkula'],
  'Himachal Pradesh': ['Shimla','Dharamshala','Mandi','Solan','Kullu','Manali','Baddi'],
  'Jharkhand': ['Ranchi','Jamshedpur','Dhanbad','Bokaro','Deoghar','Hazaribagh','Giridih'],
  'Karnataka': ['Bengaluru','Mysuru','Hubballi','Mangaluru','Belagavi','Kalaburagi','Davanagere','Ballari','Vijayapura','Shivamogga'],
  'Kerala': ['Thiruvananthapuram','Kochi','Kozhikode','Thrissur','Kollam','Palakkad','Alappuzha','Malappuram','Kannur','Kasaragod'],
  'Madhya Pradesh': ['Bhopal','Indore','Jabalpur','Gwalior','Ujjain','Sagar','Dewas','Satna','Ratlam','Rewa'],
  'Maharashtra': ['Mumbai','Pune','Nagpur','Nashik','Aurangabad','Solapur','Thane','Kolhapur','Amravati','Nanded'],
  'Manipur': ['Imphal','Thoubal','Bishnupur','Churachandpur'],
  'Meghalaya': ['Shillong','Tura','Jowai'],
  'Mizoram': ['Aizawl','Lunglei','Champhai'],
  'Nagaland': ['Kohima','Dimapur','Mokokchung'],
  'Odisha': ['Bhubaneswar','Cuttack','Rourkela','Brahmapur','Sambalpur','Puri','Balasore','Bhadrak'],
  'Punjab': ['Ludhiana','Amritsar','Jalandhar','Patiala','Bathinda','Mohali','Hoshiarpur','Gurdaspur'],
  'Rajasthan': ['Jaipur','Jodhpur','Udaipur','Kota','Ajmer','Bikaner','Alwar','Bharatpur','Sikar','Sri Ganganagar'],
  'Sikkim': ['Gangtok','Namchi','Gyalshing'],
  'Tamil Nadu': ['Chennai','Coimbatore','Madurai','Tiruchirappalli','Salem','Tirunelveli','Vellore','Erode','Thoothukudi','Dindigul'],
  'Telangana': ['Hyderabad','Warangal','Nizamabad','Karimnagar','Khammam','Ramagundam','Mahbubnagar'],
  'Tripura': ['Agartala','Udaipur','Dharmanagar'],
  'Uttar Pradesh': ['Lucknow','Kanpur','Agra','Varanasi','Prayagraj','Meerut','Ghaziabad','Noida','Bareilly','Moradabad','Aligarh','Gorakhpur','Mathura','Firozabad'],
  'Uttarakhand': ['Dehradun','Haridwar','Roorkee','Haldwani','Rudrapur','Kashipur','Rishikesh'],
  'West Bengal': ['Kolkata','Howrah','Durgapur','Asansol','Siliguri','Bardhaman','Malda','Baharampur'],
  'Delhi': ['New Delhi','North Delhi','South Delhi','East Delhi','West Delhi','Central Delhi','Dwarka','Rohini','Janakpuri'],
  'Jammu & Kashmir': ['Srinagar','Jammu','Anantnag','Baramulla','Sopore','Kathua'],
  'Ladakh': ['Leh','Kargil'],
  'Chandigarh': ['Chandigarh'],
  'Puducherry': ['Puducherry','Karaikal','Mahe','Yanam'],
  'Andaman & Nicobar Islands': ['Port Blair'],
  'Dadra & Nagar Haveli and Daman & Diu': ['Daman','Diu','Silvassa'],
  'Lakshadweep': ['Kavaratti']
};

function ProviderRegistration({ currentUser }) {
  const [formData, setFormData] = useState({
    // Section 1: Basic Information
    fullName: '',
    businessName: '',
    dob: '',
    gender: '',
    qualification: '',
    specialization: '',
    experience: '',
    languages: [],

    // Section 2: Contact & Identification
    permanentAddress: '',
    officeAddress: '',
    city: '',
    state: '',
    pinCode: '',
    mobile: '',
    whatsapp: '',
    email: '',
    website: '',
    aadhaarPan: '',
    gstin: '',

    // Section 3: Professional & Service Details
    servicesOffered: [],
    subjectsCovered: '',
    deliveryTime: '',
    paymentMethods: '',
    gstRegistered: '',
    gstNumber: '',

    // Section 4: Work Policies & Ethics
    refundPolicy: '',
    revisionPolicy: '',
    dataType: '',
    previousComplaints: '',
    allowReviews: '',

    // Section 6: Declaration
    declarationName: '',
    declarationDate: '',
    declarationPlace: ''
  });
  const [mobileIsWhatsapp, setMobileIsWhatsapp] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [amountPaid, setAmountPaid] = useState('');
  const [registrationId, setRegistrationId] = useState('');
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [billingCycle, setBillingCycle] = useState('annual'); // 'annual' | 'monthly'

  // Package catalog: source of truth for prices & durations.
  const PACKAGE_CATALOG = {
    1: { name: 'Verification & Accreditation', annual: 10000, monthly: 1500 },
    2: { name: 'Research Integrity Review',    annual: 20000, monthly: 2500 },
    3: { name: 'COMBO Package',                annual: 28000, monthly: 3800 }
  };

  const buildPlan = (id, cycle) => {
    const p = PACKAGE_CATALOG[id];
    return {
      package: id,
      name: p.name,
      duration: cycle === 'annual' ? 12 : 1,
      amount: cycle === 'annual' ? p.annual : p.monthly,
      billingCycle: cycle
    };
  };

  const handleSelectPlan = (id) => {
    setSelectedPlan(prev =>
      prev?.package === id && prev?.billingCycle === billingCycle ? null : buildPlan(id, billingCycle)
    );
  };

  // When billing cycle changes, refresh the selected plan to match the new cycle.
  // Individual Package (4) is monthly-only — clear it if user switches to annual.
  useEffect(() => {
    if (!selectedPlan) return;
    if (selectedPlan.package === 4) {
      if (billingCycle === 'annual') {
        setSelectedPlan(null);
      }
      return; // Individual Package is one-time; don't rebuild from catalog
    }
    setSelectedPlan(buildPlan(selectedPlan.package, billingCycle));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingCycle]);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

  // Auto-populate user fields and set today's date
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setFormData(prev => ({ ...prev, declarationDate: today }));
  }, []);

  useEffect(() => {
    if (currentUser) {
      setFormData(prev => ({
        ...prev,
        fullName: currentUser.name || '',
        email: currentUser.email || '',
        mobile: currentUser.phone || ''
      }));
    }
  }, [currentUser]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      const currentServices = formData.servicesOffered;
      if (checked) {
        setFormData({ ...formData, servicesOffered: [...currentServices, value] });
      } else {
        setFormData({ ...formData, servicesOffered: currentServices.filter(s => s !== value) });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
    if (formErrors[name]) setFormErrors({ ...formErrors, [name]: '' });
  };

  const addLanguage = (lang) => {
    if (lang && !formData.languages.includes(lang)) {
      setFormData({ ...formData, languages: [...formData.languages, lang] });
      if (formErrors.languages) setFormErrors({ ...formErrors, languages: '' });
    }
  };

  const removeLanguage = (lang) => {
    setFormData({ ...formData, languages: formData.languages.filter(l => l !== lang) });
  };

  const validateForm = () => {
    const errors = {};
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Helper: parse YYYY-MM-DD as local date (avoids UTC timezone offset issues)
    const parseLocalDate = (str) => {
      const [y, m, d] = str.split('-').map(Number);
      return new Date(y, m - 1, d);
    };

    // 1. DOB: not future
    if (formData.dob) {
      const dob = parseLocalDate(formData.dob);
      if (dob >= today) errors.dob = 'Date of birth cannot be today or a future date.';
    }

    // 3. Declaration date: cannot be future
    if (formData.declarationDate) {
      const declDate = parseLocalDate(formData.declarationDate);
      if (declDate > today) errors.declarationDate = 'Declaration date cannot be in the future.';
    }

    // 4. GST number format (if provided)
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (formData.gstin && !gstRegex.test(formData.gstin.toUpperCase()))
      errors.gstin = 'Invalid GSTIN format. Example: 22AAAAA0000A1Z5';
    if (formData.gstNumber && !gstRegex.test(formData.gstNumber.toUpperCase()))
      errors.gstNumber = 'Invalid GST number format. Example: 22AAAAA0000A1Z5';

    // 5. Mobile & WhatsApp: 10-digit Indian number
    const phoneRegex = /^[6-9][0-9]{9}$/;
    if (formData.mobile && !phoneRegex.test(formData.mobile))
      errors.mobile = 'Enter a valid 10-digit mobile number (starting with 6–9).';
    if (!mobileIsWhatsapp && formData.whatsapp && !phoneRegex.test(formData.whatsapp))
      errors.whatsapp = 'Enter a valid 10-digit WhatsApp number (starting with 6–9).';

    // 6. Email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email))
      errors.email = 'Enter a valid email address.';

    // 7. Aadhaar (12 digits) or PAN (ABCDE1234F)
    if (formData.aadhaarPan) {
      const aadhaarRegex = /^[0-9]{12}$/;
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      const val = formData.aadhaarPan.replace(/\s/g, '').toUpperCase();
      if (!aadhaarRegex.test(val) && !panRegex.test(val))
        errors.aadhaarPan = 'Enter a valid Aadhaar number (12 digits) or PAN card (e.g., ABCDE1234F).';
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      const firstError = document.querySelector('.field-error');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    setFormErrors({});

    // Prepare data for submission
    const registrationData = {
      name: formData.businessName || formData.fullName,
      founded: new Date(formData.dob).getFullYear().toString(),
      specialization: formData.specialization,
      location: `${formData.city}, ${formData.state}`,
      email: formData.email,
      phone: formData.mobile,
      website: formData.website,
      completedProjects: formData.experience ? `${formData.experience} years experience` : 'N/A',
      languages: Array.isArray(formData.languages) ? formData.languages.join(', ') : formData.languages
    };

    // Add userId if user is logged in
    if (currentUser && currentUser.id) {
      registrationData.userId = currentUser.id;
    }

    try {
      const response = await fetch(`${API_URL}/pending-registrations`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(registrationData),
      });

      const result = await response.json();

      if (result.success) {
        console.log('Registration submitted successfully:', result);
        setRegistrationId(result.registrationId || result.id);
        setSubmitted(true);
        setShowSubscriptionModal(true);
      } else {
        console.error('Failed to submit registration:', result.message);
      }
    } catch (error) {
      console.error('Error submitting registration:', error);
    }
  };

  const attachPackage = async () => {
    if (!registrationId || !selectedPlan) return { success: false };
    try {
      const response = await fetch(`${API_URL}/pending-registrations/${registrationId}/package`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          packageId: selectedPlan.package,
          packageName: selectedPlan.name,
          packageAmount: selectedPlan.amount,
          packageDuration: selectedPlan.duration,
        }),
      });
      return await response.json();
    } catch (error) {
      console.error('Error attaching package:', error);
      return { success: false };
    }
  };

  const handlePaymentDone = async () => {
    if (!amountPaid || Number(amountPaid) <= 0) {
      alert('Please enter the amount you paid.');
      return;
    }
    try {
      const response = await fetch(`${API_URL}/pending-registrations/${registrationId}/payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ amountPaid: Number(amountPaid) }),
      });

      const result = await response.json();

      if (result.success) {
        setPaymentCompleted(true);
        setShowPaymentModal(false);
      } else {
        console.error('Failed to update payment status:', result.message);
      }
    } catch (error) {
      console.error('Error updating payment:', error);
    }
  };

  const isFormComplete = Boolean(
    formData.fullName && formData.dob && formData.gender &&
    formData.qualification && formData.specialization && formData.experience &&
    formData.languages.length > 0 && formData.permanentAddress &&
    formData.city && formData.state && formData.pinCode &&
    formData.mobile && (mobileIsWhatsapp || formData.whatsapp) && formData.email &&
    formData.aadhaarPan && formData.servicesOffered.length > 0 &&
    formData.subjectsCovered && formData.deliveryTime && formData.paymentMethods &&
    formData.gstRegistered && (formData.gstRegistered === 'no' || formData.gstNumber) &&
    formData.refundPolicy && formData.revisionPolicy && formData.dataType &&
    formData.previousComplaints && formData.allowReviews &&
    formData.declarationName && formData.declarationDate && formData.declarationPlace
  );

  return (
    <div className="tab-content">
      <h2>Provider Registration & Verification</h2>

      <div style={{ marginBottom: '30px' }}>
        <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
          This form must be filled out completely and truthfully by any thesis provider, researcher, or consultant applying for verification and accreditation by Thesis Guard India.
          Incomplete or false information will lead to automatic rejection or blacklisting.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Section 1: Basic Information */}
        <div style={{ marginBottom: '40px' }}>
          <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
            Section 1: Basic Information
          </h3>

          <div className="form-group">
            <label htmlFor="fullName">Full Name *</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="businessName">Business / Agency Name (if any)</label>
            <input
              type="text"
              id="businessName"
              name="businessName"
              value={formData.businessName}
              onChange={handleChange}
            />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div className="form-group">
              <label htmlFor="dob">Date of Birth *</label>
              <input
                type="date"
                id="dob"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]}
                required
              />
              {formErrors.dob && <span className="field-error" style={{ color: '#e74c3c', fontSize: '13px' }}>{formErrors.dob}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="gender">Gender *</label>
              <select
                id="gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="qualification">Qualification (UG/PG/PhD) *</label>
            <input
              type="text"
              id="qualification"
              name="qualification"
              value={formData.qualification}
              onChange={handleChange}
              placeholder="e.g., PhD in Economics"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="specialization">Field / Specialization *</label>
            <input
              type="text"
              id="specialization"
              name="specialization"
              value={formData.specialization}
              onChange={handleChange}
              placeholder="e.g., Financial Research, Data Analytics"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="experience">Years of Experience in Thesis / Research Support *</label>
            <input
              type="number"
              id="experience"
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              min="0"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="languages">Languages Known *</label>
            <select
              id="languages"
              value=""
              onChange={(e) => addLanguage(e.target.value)}
            >
              <option value="" disabled>-- Select a language --</option>
              {['Hindi', 'English'].filter(l => !formData.languages.includes(l)).map(lang => (
                <option key={lang} value={lang}>{lang}</option>
              ))}
            </select>
            {formData.languages.length > 0 && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                {formData.languages.map(lang => (
                  <span key={lang} style={{
                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                    backgroundColor: '#3498db', color: 'white',
                    padding: '4px 10px', borderRadius: '20px', fontSize: '14px'
                  }}>
                    {lang}
                    <button type="button" onClick={() => removeLanguage(lang)} style={{
                      background: 'none', border: 'none', color: 'white',
                      cursor: 'pointer', fontSize: '16px', lineHeight: 1, padding: 0
                    }}>×</button>
                  </span>
                ))}
              </div>
            )}
            {formErrors.languages && <span className="field-error" style={{ color: '#e74c3c', fontSize: '13px' }}>{formErrors.languages}</span>}
          </div>
        </div>

        {/* Section 2: Contact & Identification */}
        <div style={{ marginBottom: '40px' }}>
          <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
            Section 2: Contact & Identification
          </h3>

          <div className="form-group">
            <label htmlFor="permanentAddress">Permanent Address *</label>
            <textarea
              id="permanentAddress"
              name="permanentAddress"
              value={formData.permanentAddress}
              onChange={handleChange}
              rows="2"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="officeAddress">Office Address</label>
            <textarea
              id="officeAddress"
              name="officeAddress"
              value={formData.officeAddress}
              onChange={handleChange}
              rows="2"
            />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
            <div className="form-group">
              <label htmlFor="state">State *</label>
              <select
                id="state"
                name="state"
                value={formData.state}
                onChange={(e) => setFormData({ ...formData, state: e.target.value, city: '' })}
                required
              >
                <option value="">Select State</option>
                {Object.keys(INDIA_CITIES).sort().map(s => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="city">City *</label>
              <select
                id="city"
                name="city"
                value={formData.city}
                onChange={handleChange}
                required
                disabled={!formData.state}
              >
                <option value="">{formData.state ? 'Select City' : 'Select State first'}</option>
                {(INDIA_CITIES[formData.state] || []).map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="pinCode">PIN Code *</label>
              <input
                type="text"
                id="pinCode"
                name="pinCode"
                value={formData.pinCode}
                onChange={handleChange}
                pattern="[0-9]{6}"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="mobile">Mobile Number *</label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="10-digit number"
              maxLength="10"
              required
            />
            {formErrors.mobile && <span className="field-error" style={{ color: '#e74c3c', fontSize: '13px' }}>{formErrors.mobile}</span>}
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px', fontWeight: 'normal', fontSize: '14px', cursor: 'pointer', color: '#555' }}>
              <input
                type="checkbox"
                checked={mobileIsWhatsapp}
                onChange={(e) => {
                  setMobileIsWhatsapp(e.target.checked);
                  if (e.target.checked) setFormData(prev => ({ ...prev, whatsapp: '' }));
                }}
                style={{ width: '16px', height: '16px', cursor: 'pointer' }}
              />
              This is also my WhatsApp number
            </label>
          </div>

          {!mobileIsWhatsapp && (
            <div className="form-group">
              <label htmlFor="whatsapp">WhatsApp Number *</label>
              <input
                type="tel"
                id="whatsapp"
                name="whatsapp"
                value={formData.whatsapp}
                onChange={handleChange}
                placeholder="10-digit number"
                maxLength="10"
                required
              />
              {formErrors.whatsapp && <span className="field-error" style={{ color: '#e74c3c', fontSize: '13px' }}>{formErrors.whatsapp}</span>}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email ID *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {formErrors.email && <span className="field-error" style={{ color: '#e74c3c', fontSize: '13px' }}>{formErrors.email}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="website">Website / Social Media Links (if any)</label>
            <input
              type="url"
              id="website"
              name="website"
              value={formData.website}
              onChange={handleChange}
              placeholder="https://"
            />
          </div>

          <div className="form-group">
            <label htmlFor="aadhaarPan">Aadhaar / PAN Card Number *</label>
            <input
              type="text"
              id="aadhaarPan"
              name="aadhaarPan"
              value={formData.aadhaarPan}
              onChange={handleChange}
              required
            />
            {formErrors.aadhaarPan && <span className="field-error" style={{ color: '#e74c3c', fontSize: '13px' }}>{formErrors.aadhaarPan}</span>}
            <small style={{ fontSize: '13px', color: '#777' }}>
              (ID Proof, passport size photo, and sample work will be collected during verification process)
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="gstin">GSTIN (if applicable)</label>
            <input
              type="text"
              id="gstin"
              name="gstin"
              value={formData.gstin}
              onChange={handleChange}
              placeholder="Enter GST Number (e.g., 22AAAAA0000A1Z5)"
              maxLength="15"
            />
            {formErrors.gstin && <span className="field-error" style={{ color: '#e74c3c', fontSize: '13px' }}>{formErrors.gstin}</span>}
          </div>
        </div>

        {/* Section 3: Professional & Service Details */}
        <div style={{ marginBottom: '40px' }}>
          <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
            Section 3: Professional & Service Details
          </h3>

          <div className="form-group">
            <label>Type of Services Offered (select all applicable) *</label>
            <div style={{ display: 'grid', gap: '10px', marginTop: '10px' }}>
              {[
                'Thesis Writing',
                'Data Analysis (SPSS / R / STATA)',
                'Plagiarism Removal / Editing',
                'Formatting & Layout',
                'Presentation Preparation',
                'Research Guidance Only'
              ].map(service => (
                <label key={service} style={{ display: 'flex', alignItems: 'center', fontSize: '15px' }}>
                  <input
                    type="checkbox"
                    value={service}
                    checked={formData.servicesOffered.includes(service)}
                    onChange={handleChange}
                    style={{ marginRight: '10px', width: 'auto' }}
                  />
                  {service}
                </label>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="subjectsCovered">Subjects Covered *</label>
            <input
              type="text"
              id="subjectsCovered"
              name="subjectsCovered"
              value={formData.subjectsCovered}
              onChange={handleChange}
              placeholder="e.g., Economics, Finance, Statistics, Management"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="deliveryTime">Average Delivery Time per Project *</label>
            <input
              type="text"
              id="deliveryTime"
              name="deliveryTime"
              value={formData.deliveryTime}
              onChange={handleChange}
              placeholder="e.g., 15-30 days"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="paymentMethods">Payment Methods Accepted *</label>
            <input
              type="text"
              id="paymentMethods"
              name="paymentMethods"
              value={formData.paymentMethods}
              onChange={handleChange}
              placeholder="e.g., UPI, Bank Transfer, PayPal"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="gstRegistered">Are you GST Registered? *</label>
            <select
              id="gstRegistered"
              name="gstRegistered"
              value={formData.gstRegistered}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>

          {formData.gstRegistered === 'yes' && (
            <div className="form-group">
              <label htmlFor="gstNumber">GST Number *</label>
              <input
                type="text"
                id="gstNumber"
                name="gstNumber"
                value={formData.gstNumber}
                onChange={handleChange}
                placeholder="e.g., 22AAAAA0000A1Z5"
                maxLength="15"
                required
              />
              {formErrors.gstNumber && <span className="field-error" style={{ color: '#e74c3c', fontSize: '13px' }}>{formErrors.gstNumber}</span>}
            </div>
          )}
        </div>

        {/* Section 4: Work Policies & Ethics */}
        <div style={{ marginBottom: '40px' }}>
          <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
            Section 4: Work Policies & Ethics
          </h3>

          <div className="form-group">
            <label htmlFor="refundPolicy">Refund Policy (Describe) *</label>
            <textarea
              id="refundPolicy"
              name="refundPolicy"
              value={formData.refundPolicy}
              onChange={handleChange}
              rows="3"
              placeholder="Describe your refund policy, terms, and conditions"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="revisionPolicy">Changes/Revisions Policy (Describe) *</label>
            <textarea
              id="revisionPolicy"
              name="revisionPolicy"
              value={formData.revisionPolicy}
              onChange={handleChange}
              rows="3"
              placeholder="Describe your policy for client-requested changes and revisions"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="dataType">Do you use real or sample data for analysis? *</label>
            <select
              id="dataType"
              name="dataType"
              value={formData.dataType}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="real">Real Data (Collected by Client)</option>
              <option value="sample">Sample Data</option>
              <option value="both">Both (As per client requirement)</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="previousComplaints">Have you ever been reported or complained against by a client? *</label>
            <select
              id="previousComplaints"
              name="previousComplaints"
              value={formData.previousComplaints}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="allowReviews">Do you allow client feedback/reviews to be published? *</label>
            <select
              id="allowReviews"
              name="allowReviews"
              value={formData.allowReviews}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>
        </div>

        {/* Section 5: Declaration */}
        <div style={{ marginBottom: '40px' }}>
          <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
            Section 5: Declaration
          </h3>

          <div style={{
            backgroundColor: '#fff3cd',
            border: '1px solid #f39c12',
            borderRadius: '5px',
            padding: '15px',
            marginBottom: '20px'
          }}>
            <p style={{ fontSize: '14px', lineHeight: '1.6', margin: '0 0 15px 0' }}>
              I hereby declare that all information provided above is true to the best of my knowledge.
              I understand that GLOBAL RESEARCH ORGANISATION reserves the right to verify the authenticity of
              this data and to revoke my verification at any time if fraudulent or unethical activity is found.
            </p>
            <p style={{ fontSize: '14px', lineHeight: '1.6', margin: '0' }}>
              I agree to comply with the Code of Ethics and Accreditation Terms of GLOBAL RESEARCH ORGANISATION,
              and allow my profile information to be displayed publicly for student verification purposes.
            </p>
          </div>

          <div className="form-group">
            <label htmlFor="declarationName">Full Name for Declaration *</label>
            <input
              type="text"
              id="declarationName"
              name="declarationName"
              value={formData.declarationName}
              onChange={handleChange}
              required
            />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div className="form-group">
              <label htmlFor="declarationDate">Date *</label>
              <input
                type="date"
                id="declarationDate"
                name="declarationDate"
                value={formData.declarationDate}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]}
                required
              />
              {formErrors.declarationDate && <span className="field-error" style={{ color: '#e74c3c', fontSize: '13px' }}>{formErrors.declarationDate}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="declarationPlace">Place *</label>
              <input
                type="text"
                id="declarationPlace"
                name="declarationPlace"
                value={formData.declarationPlace}
                onChange={(e) => {
                  const filtered = e.target.value.replace(/[^A-Za-z\s]/g, '');
                  setFormData(prev => ({ ...prev, declarationPlace: filtered }));
                }}
                required
              />
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="submit-btn"
          disabled={!isFormComplete}
          style={{
            backgroundColor: isFormComplete ? '#27ae60' : '#95a5a6',
            borderColor: isFormComplete ? '#27ae60' : '#95a5a6',
            cursor: isFormComplete ? 'pointer' : 'not-allowed',
            opacity: isFormComplete ? 1 : 0.7
          }}
        >
          Submit Registration Application
        </button>
        {!isFormComplete && (
          <p style={{ textAlign: 'center', color: '#888', fontSize: '13px', marginTop: '8px' }}>
            Please fill all required fields (*) to enable submission.
          </p>
        )}
      </form>

      {submitted && !showPaymentModal && !paymentCompleted && (
        <div className="success-message">
          Your registration application has been submitted successfully! Application ID will be sent to your email.
          Our verification team will review your application and contact you within 5-7 business days with next steps,
          including document submission requirements.
        </div>
      )}

      {paymentCompleted && (
        <div className="success-message">
          Thank you! We've received your application and will review it within 24-48 hours. You'll get an email once it's approved.
        </div>
      )}

      {/* Subscription Plan Modal */}
      {showSubscriptionModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '40px',
            borderRadius: '10px',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            position: 'relative'
          }}>
            <button
              onClick={() => {
                setShowSubscriptionModal(false);
                setSelectedPlan(null);
              }}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                backgroundColor: 'transparent',
                border: 'none',
                fontSize: '24px',
                color: '#95a5a6',
                cursor: 'pointer',
                padding: '0',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#f0f0f0';
                e.target.style.color = '#2c3e50';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#95a5a6';
              }}
            >
              ×
            </button>
            <h3 style={{ color: '#2c3e50', marginBottom: '10px', textAlign: 'center' }}>
              Choose Your Service Package
            </h3>
            <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px', fontSize: '14px' }}>
              Select the package that best fits your needs
            </p>

            {/* Billing cycle toggle (only applies to subscription packages 1-3) */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '20px'
            }}>
              <div style={{
                display: 'inline-flex',
                backgroundColor: '#ecf0f1',
                borderRadius: '999px',
                padding: '4px',
                gap: '4px'
              }}>
                <button
                  type="button"
                  onClick={() => setBillingCycle('annual')}
                  style={{
                    padding: '8px 18px',
                    border: 'none',
                    borderRadius: '999px',
                    backgroundColor: billingCycle === 'annual' ? '#2c3e50' : 'transparent',
                    color: billingCycle === 'annual' ? 'white' : '#2c3e50',
                    fontSize: '13px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                  Annual <span style={{ fontSize: '11px', opacity: 0.85 }}>(save up to 17%)</span>
                </button>
                <button
                  type="button"
                  onClick={() => setBillingCycle('monthly')}
                  style={{
                    padding: '8px 18px',
                    border: 'none',
                    borderRadius: '999px',
                    backgroundColor: billingCycle === 'monthly' ? '#2c3e50' : 'transparent',
                    color: billingCycle === 'monthly' ? 'white' : '#2c3e50',
                    fontSize: '13px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                  Monthly
                </button>
              </div>
            </div>
            <p style={{ textAlign: 'center', color: '#999', fontSize: '12px', marginTop: '-10px', marginBottom: '20px' }}>
              Subscription billing applies to Packages 1, 2, and 3. Individual Package is one-time.
            </p>

            <div style={{ display: 'grid', gap: '20px', marginBottom: '30px' }}>
              {/* Package 1 - Verification & Accreditation */}
              <div
                onClick={() => handleSelectPlan(1)}
                style={{
                  border: selectedPlan?.package === 1 ? '3px solid #27ae60' : '2px solid #ddd',
                  borderRadius: '10px',
                  padding: '20px',
                  cursor: 'pointer',
                  backgroundColor: selectedPlan?.package === 1 ? '#e8f5e9' : 'white',
                  transition: 'all 0.3s ease',
                  position: 'relative'
                }}
              >
                {selectedPlan?.package === 1 && (
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    backgroundColor: '#27ae60',
                    color: 'white',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </div>
                )}
                <div style={{ backgroundColor: '#27ae60', color: 'white', padding: '4px 8px', borderRadius: '5px', display: 'inline-block', marginBottom: '10px', fontSize: '11px', fontWeight: 'bold' }}>
                  PACKAGE 1
                </div>
                <h4 style={{ color: '#2c3e50', marginBottom: '10px', fontSize: '18px' }}>
                  Verification & Accreditation Package
                </h4>
                <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#27ae60', margin: '10px 0' }}>
                  {billingCycle === 'annual'
                    ? `₹${PACKAGE_CATALOG[1].annual.toLocaleString('en-IN')}/year`
                    : `₹${PACKAGE_CATALOG[1].monthly.toLocaleString('en-IN')}/month`}
                </p>
                {billingCycle === 'annual' && (
                  <p style={{ fontSize: '12px', color: '#27ae60', margin: '0 0 10px 0', fontWeight: '600' }}>
                    Save ₹{(PACKAGE_CATALOG[1].monthly * 12 - PACKAGE_CATALOG[1].annual).toLocaleString('en-IN')} vs monthly
                  </p>
                )}
                {billingCycle === 'monthly' && (
                  <p style={{ fontSize: '12px', color: '#999', margin: '0 0 10px 0' }}>
                    Auto-debit · cancel anytime
                  </p>
                )}
                <ul style={{ fontSize: '13px', color: '#666', lineHeight: '1.6', paddingLeft: '20px', margin: '10px 0' }}>
                  <li>Identity + qualifications verification</li>
                  <li>Ethics & authenticity compliance check</li>
                  <li>Authenticity Barcode (Verification Barcode)</li>
                  <li>Public Verified Provider Profile</li>
                  <li>Directory listing</li>
                  <li>Complaint-resolution support</li>
                </ul>
              </div>

              {/* Package 2 - Research Integrity Review */}
              <div
                onClick={() => handleSelectPlan(2)}
                style={{
                  border: selectedPlan?.package === 2 ? '3px solid #2980b9' : '2px solid #ddd',
                  borderRadius: '10px',
                  padding: '20px',
                  cursor: 'pointer',
                  backgroundColor: selectedPlan?.package === 2 ? '#e3f2fd' : 'white',
                  transition: 'all 0.3s ease',
                  position: 'relative'
                }}
              >
                {selectedPlan?.package === 2 && (
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    backgroundColor: '#2980b9',
                    color: 'white',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </div>
                )}
                <div style={{ backgroundColor: '#2980b9', color: 'white', padding: '4px 8px', borderRadius: '5px', display: 'inline-block', marginBottom: '10px', fontSize: '11px', fontWeight: 'bold' }}>
                  PACKAGE 2
                </div>
                <h4 style={{ color: '#2c3e50', marginBottom: '10px', fontSize: '18px' }}>
                  Research Integrity Review (RIR Package)
                </h4>
                <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#2980b9', margin: '10px 0' }}>
                  {billingCycle === 'annual'
                    ? `₹${PACKAGE_CATALOG[2].annual.toLocaleString('en-IN')}/year`
                    : `₹${PACKAGE_CATALOG[2].monthly.toLocaleString('en-IN')}/month`}
                </p>
                {billingCycle === 'annual' && (
                  <p style={{ fontSize: '12px', color: '#2980b9', margin: '0 0 10px 0', fontWeight: '600' }}>
                    Save ₹{(PACKAGE_CATALOG[2].monthly * 12 - PACKAGE_CATALOG[2].annual).toLocaleString('en-IN')} vs monthly
                  </p>
                )}
                {billingCycle === 'monthly' && (
                  <p style={{ fontSize: '12px', color: '#999', margin: '0 0 10px 0' }}>
                    Auto-debit · cancel anytime
                  </p>
                )}
                <ul style={{ fontSize: '13px', color: '#666', lineHeight: '1.6', paddingLeft: '20px', margin: '10px 0' }}>
                  <li>12 submissions per year</li>
                  <li>Full authenticity check</li>
                  <li>Plagiarism screening</li>
                  <li>Data integrity check</li>
                  <li>Ethical compliance review</li>
                  <li>Priority 24–48 hr review</li>
                </ul>
              </div>

              {/* Package 3 - COMBO Package */}
              <div
                onClick={() => handleSelectPlan(3)}
                style={{
                  border: selectedPlan?.package === 3 ? '3px solid #f39c12' : '2px solid #ddd',
                  borderRadius: '10px',
                  padding: '20px',
                  cursor: 'pointer',
                  backgroundColor: selectedPlan?.package === 3 ? '#fff8e1' : 'white',
                  transition: 'all 0.3s ease',
                  position: 'relative'
                }}
              >
                <div style={{
                  position: 'absolute',
                  top: '10px',
                  right: selectedPlan?.package === 3 ? '40px' : '10px',
                  backgroundColor: '#e74c3c',
                  color: 'white',
                  borderRadius: '5px',
                  padding: '4px 8px',
                  fontSize: '11px',
                  fontWeight: 'bold'
                }}>
                  BEST VALUE 🔥
                </div>
                {selectedPlan?.package === 3 && (
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    backgroundColor: '#f39c12',
                    color: 'white',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </div>
                )}
                <div style={{ backgroundColor: '#f39c12', color: 'white', padding: '4px 8px', borderRadius: '5px', display: 'inline-block', marginBottom: '10px', fontSize: '11px', fontWeight: 'bold' }}>
                  PACKAGE 3 - COMBO
                </div>
                <h4 style={{ color: '#2c3e50', marginBottom: '10px', fontSize: '18px' }}>
                  COMBO Package (Package 1 + 2)
                </h4>
                <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#f39c12', margin: '10px 0' }}>
                  {billingCycle === 'annual'
                    ? `₹${PACKAGE_CATALOG[3].annual.toLocaleString('en-IN')}/year`
                    : `₹${PACKAGE_CATALOG[3].monthly.toLocaleString('en-IN')}/month`}
                </p>
                {billingCycle === 'annual' && (
                  <p style={{ fontSize: '12px', color: '#f39c12', margin: '0 0 10px 0', fontWeight: '600' }}>
                    Save ₹{(PACKAGE_CATALOG[3].monthly * 12 - PACKAGE_CATALOG[3].annual).toLocaleString('en-IN')} vs monthly
                  </p>
                )}
                {billingCycle === 'monthly' && (
                  <p style={{ fontSize: '12px', color: '#999', margin: '0 0 10px 0' }}>
                    Auto-debit · cancel anytime
                  </p>
                )}
                <ul style={{ fontSize: '13px', color: '#666', lineHeight: '1.6', paddingLeft: '20px', margin: '10px 0' }}>
                  <li><strong>ALL from Package 1 + Package 2</strong></li>
                  <li>Premium badge (Verification + RIR)</li>
                  <li>Higher directory ranking</li>
                  <li>12 research checks per year</li>
                  <li>Unified dashboard</li>
                  <li>Priority priority support</li>
                </ul>
              </div>

              {/* Individual Package — shown only in Monthly view (one-time, low-commitment offline service) */}
              {billingCycle === 'monthly' && (
              <div
                onClick={() => setSelectedPlan(selectedPlan?.package === 4 ? null : { package: 4, name: 'Individual Package', duration: 0, amount: 1000, billingCycle: 'one-time' })}
                style={{
                  border: selectedPlan?.package === 4 ? '3px solid #8e44ad' : '2px solid #ddd',
                  borderRadius: '10px',
                  padding: '20px',
                  cursor: 'pointer',
                  backgroundColor: selectedPlan?.package === 4 ? '#f3e5f5' : 'white',
                  transition: 'all 0.3s ease',
                  position: 'relative'
                }}
              >
                {selectedPlan?.package === 4 && (
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    backgroundColor: '#8e44ad',
                    color: 'white',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </div>
                )}
                <div style={{ backgroundColor: '#8e44ad', color: 'white', padding: '4px 8px', borderRadius: '5px', display: 'inline-block', marginBottom: '10px', fontSize: '11px', fontWeight: 'bold' }}>
                  INDIVIDUAL PACKAGE
                </div>
                <h4 style={{ color: '#2c3e50', marginBottom: '10px', fontSize: '18px' }}>
                  One-Time Research Check
                </h4>
                <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#8e44ad', margin: '10px 0' }}>
                  ₹1,000
                </p>
                <p style={{ fontSize: '12px', color: '#e74c3c', margin: '0 0 10px 0', fontWeight: 'bold' }}>
                  ONE-TIME • NO AUTO RENEWAL
                </p>
                <ul style={{ fontSize: '13px', color: '#666', lineHeight: '1.6', paddingLeft: '20px', margin: '10px 0' }}>
                  <li>1-time Authenticity Check</li>
                  <li>Error identification</li>
                  <li>Correction suggestions</li>
                  <li>Format + structure review</li>
                  <li>Basic plagiarism insight</li>
                  <li>24–48 hour delivery</li>
                </ul>
              </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={async () => {
                  if (selectedPlan) {
                    await attachPackage();
                    setShowSubscriptionModal(false);
                    setShowPaymentModal(true);
                  } else {
                    console.error('Please select a subscription plan to continue');
                  }
                }}
                disabled={!selectedPlan}
                style={{
                  flex: 1,
                  backgroundColor: selectedPlan ? '#27ae60' : '#95a5a6',
                  color: 'white',
                  border: 'none',
                  padding: '14px',
                  borderRadius: '5px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: selectedPlan ? 'pointer' : 'not-allowed',
                  opacity: selectedPlan ? 1 : 0.6
                }}
              >
                Proceed to Payment
              </button>
              <button
                onClick={() => {
                  setShowSubscriptionModal(false);
                  setSelectedPlan(null);
                }}
                style={{
                  flex: 1,
                  backgroundColor: '#95a5a6',
                  color: 'white',
                  border: 'none',
                  padding: '14px',
                  borderRadius: '5px',
                  fontSize: '16px',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Payment Modal */}
      {showPaymentModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '40px',
            borderRadius: '10px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            position: 'relative',
            maxHeight: '90vh',
            overflowY: 'auto'
          }}>
            <button
              onClick={() => setShowPaymentModal(false)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                backgroundColor: 'transparent',
                border: 'none',
                fontSize: '24px',
                color: '#95a5a6',
                cursor: 'pointer',
                padding: '0',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#f0f0f0';
                e.target.style.color = '#2c3e50';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#95a5a6';
              }}
            >
              ×
            </button>
            <h3 style={{ color: '#2c3e50', marginBottom: '20px', textAlign: 'center' }}>
              Complete Your Payment
            </h3>

            <div style={{
              backgroundColor: '#e8f5e9',
              border: '2px solid #27ae60',
              borderRadius: '8px',
              padding: '20px',
              marginBottom: '25px',
              textAlign: 'center'
            }}>
              <p style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#666' }}>
                {selectedPlan?.name}
              </p>
              <p style={{ margin: '0 0 15px 0', fontSize: '28px', fontWeight: 'bold', color: '#27ae60' }}>
                ₹{selectedPlan?.amount.toLocaleString('en-IN')}
                {selectedPlan?.duration > 0 && '/year'}
                {selectedPlan?.duration === 0 && ' (One-time)'}
              </p>
              <p style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#555' }}>
                Registration ID: <strong>{registrationId}</strong>
              </p>
            </div>

            <div style={{
              backgroundColor: '#f8f9fa',
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '20px',
              marginBottom: '25px'
            }}>
              <h4 style={{ margin: '0 0 15px 0', color: '#2c3e50', fontSize: '16px' }}>
                Pay via UPI
              </h4>

              <div style={{ marginBottom: '15px' }}>
                <p style={{ margin: '0', fontSize: '14px', color: '#555' }}>
                  Scan QR Code with any UPI app (GooglePay, PhonePe, Paytm)
                </p>
              </div>

              <div style={{
                backgroundColor: 'white',
                padding: '15px',
                borderRadius: '5px',
                textAlign: 'center',
                border: '2px dashed #3498db',
                marginTop: '15px'
              }}>
                <img
                  src={`${API_URL}/qr-code`}
                  alt="Payment QR Code"
                  style={{
                    width: '260px',
                    height: '260px',
                    margin: '0 auto',
                    display: 'block',
                    borderRadius: '5px',
                    objectFit: 'contain'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<div style="width:150px;height:150px;background-color:#f0f0f0;margin:0 auto;display:flex;align-items:center;justify-content:center;border-radius:5px;font-size:14px;color:#777;">QR Code Not Available</div>';
                  }}
                />
              </div>
            </div>

            <div style={{
              backgroundColor: '#fff3cd',
              border: '1px solid #f39c12',
              borderRadius: '5px',
              padding: '12px',
              marginBottom: '20px',
              fontSize: '13px',
              color: '#856404'
            }}>
              <strong>Important:</strong> Please use your Registration ID ({registrationId}) as payment reference/note
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2c3e50', fontSize: '14px' }}>
                Enter Amount Paid (₹) *
              </label>
              <input
                type="number"
                value={amountPaid}
                onChange={(e) => setAmountPaid(e.target.value)}
                placeholder="e.g. 10000"
                style={{
                  width: '100%',
                  padding: '12px',
                  fontSize: '16px',
                  border: '2px solid #ddd',
                  borderRadius: '5px',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={handlePaymentDone}
                style={{
                  flex: 1,
                  backgroundColor: '#27ae60',
                  color: 'white',
                  border: 'none',
                  padding: '12px',
                  borderRadius: '5px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                Payment Done
              </button>
              <button
                onClick={() => setShowPaymentModal(false)}
                style={{
                  flex: 1,
                  backgroundColor: '#95a5a6',
                  color: 'white',
                  border: 'none',
                  padding: '12px',
                  borderRadius: '5px',
                  fontSize: '16px',
                  cursor: 'pointer'
                }}
              >
                Pay Later
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default ProviderRegistration;
